import React from 'react';

import { getGridLayout } from '../../../../../shared/helpers/layout-manager/grid-layout';
import { Size } from '../../../../../shared/helpers/layout-manager/types';
import { GRID_ITEM_RATIO } from '../../../constants';
import { PositionHelpers } from '../hooks/useCommonLayoutStyles';

const DEFAULT_PAGE_BUTTON_STYLES: React.CSSProperties = {
    top: '50%',
    marginTop: '-22px',
    zIndex: 3,
};

export const getStartButtonStyles: PositionHelpers['getStartButtonStyles'] = () => {
    return {
        ...DEFAULT_PAGE_BUTTON_STYLES,
        left: '5px',
    };
};

export const getEndButtonStyles: PositionHelpers['getEndButtonStyles'] = () => {
    return {
        ...DEFAULT_PAGE_BUTTON_STYLES,
        right: '5px',
    };
};

export const getAreaCreator = (
    page: number,
    maxDisplayNodeCount: number,
    nodeItemRatio: GRID_ITEM_RATIO,
    isNewGrid?: boolean
): PositionHelpers['getAreas'] => {
    return (layoutSize: Size, totalCount: number) => {
        const placeCount = (() => {
            if (page > 0) {
                return maxDisplayNodeCount;
            }

            return totalCount > maxDisplayNodeCount ? maxDisplayNodeCount : totalCount;
        })();

        return getGridLayout(layoutSize, totalCount, placeCount, nodeItemRatio, isNewGrid).participantsListLayout;
    };
};
